import script from "./customerCikaList.vue?vue&type=script&setup=true&lang=js"
export * from "./customerCikaList.vue?vue&type=script&setup=true&lang=js"

import "./customerCikaList.vue?vue&type=style&index=0&id=cf17cf06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf17cf06"]])

export default __exports__